export const UserListCardSkeleton: React.FC = () => (
  <div className='bg-surface rounded-[30px] overflow-hidden animate-pulse'>
    <div className='relative w-full bg-surface border border-skeleton-border px-5 py-3'>
      <div className='text-left relative flex items-start justify-start grow gap-[10px] sm:gap-[20px]'>
        <div className='mt-[5px]'>
          <div className='w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] rounded-[20px] sm:rounded-[25px] bg-skeleton-hi' />
        </div>
        <div className='flex flex-col gap-[10px] grow overflow-hidden'>
          <div className=' '>
            <div className='h-[22px] w-[70%] rounded-lg bg-skeleton-hi mb-[5px]' />
            <div className='h-[18px] w-[40%] rounded-lg bg-skeleton-hi' />
          </div>
          <div className='flex items-center justify-start gap-[10px] leading-[1em]'>
            <div className='flex items-center justify-between bg-skeleton-hi w-[50px] h-[24px] rounded-lg' />
            <div className='flex items-center justify-between bg-skeleton-hi w-[50px] h-[24px] rounded-lg' />
          </div>
        </div>
        <div className='bg-skeleton-hi w-[40px] h-[40px] sm:w-[40px] sm:h-[40px] rounded-[20px] sm:rounded-[20px] flex items-center justify-center' />
      </div>
    </div>
  </div>
)
